import loadable from '@loadable/component'

const categoryGuidesModule = {
  variations: {
    default: loadable(() => import('./wrapper'))
  }
}

export default categoryGuidesModule
